import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  private key: string

  constructor() {
    // Aquí se inicializa la clave; se puede añadir una validación
    if (!environment.keyEncrypt) {
      throw new Error('KeyEncrypt is not defined in environment.');
    }
    this.key = environment.keyEncrypt;
  }

  encrypt(data: string): string {
    return CryptoJS.AES.encrypt(data, this.key).toString();
  }

  decrypt(encryptedData: string): string | null {
    const bytes = CryptoJS.AES.decrypt(encryptedData, this.key);
    const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedValue || null;
  }

}
